/* eslint-disable react/no-danger */
import React from "react";

import styles from "./suggestions-container.module.scss";

function SuggestionsContainer({
  searchStr = null,
  suggestions = [],
  selectedSuggestion = null,
  onSuggestionSelected = () => {},
}) {
  const suggestionWithSearchStr = suggestion => {
    const re = new RegExp(searchStr, "ig");
    const textMatch = suggestion.match(re);
    return textMatch ? suggestion.replace(re, `<strong>${textMatch[0]}</strong>`) : suggestion;
  };

  return (
    <div className={styles["suggestions-container"]} role="listbox">
      <ul data-test="suggestions-container-list" role="listbox">
        {suggestions.map((suggestion, i) => (
          <li
            key={suggestion}
            className={i === selectedSuggestion ? styles["suggestions-container__selected"] : null}
            role="option"
            aria-selected={i === selectedSuggestion}
          >
            <a
              tabIndex="-1"
              data-test="suggestions-container-option"
              dangerouslySetInnerHTML={{
                __html: suggestionWithSearchStr(suggestion),
              }}
              onClick={() => onSuggestionSelected(suggestion)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SuggestionsContainer;
